import { Button, Glyphicon, Modal } from 'react-bootstrap';
import { styles } from './duplicate-record-modal-styles';

interface IProps {
    show: boolean;
    message: string;
    onClose: () => void;
}

const DuplicateRecordModal: React.FC<IProps> = ({ show, message, onClose }) => {
    return (
        <Modal backdrop='static' show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Duplicate Record Identified</Modal.Title>
            </Modal.Header>
            <Modal.Body style={styles.body}>
                <Glyphicon glyph='exclamation-sign' style={styles.icon} />

                <div style={styles.heading}>
                    This is a duplicate profile.
                </div>

                <hr style={styles.rule} />

                <div style={styles.message}>
                    {message}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={onClose}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DuplicateRecordModal;
